<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Confirmación de Datos</title>
</head>
<body [class.dark-mode]="isDarkMode">
  <div class="container" [class.dark-mode]="isDarkMode">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="container-custom" [ngClass]="{'channel-7': channel === 7}">
          <h4 class="text-center">{{ getLabel('confirmation') }}</h4>
          <div class="card-details">
            @if (this.phoneNumber !== 'null' && this.channel !==7) {
              <p><strong>{{ getLabel('phone') }}:</strong> {{ this.phoneNumber }}</p>
            }
            <!-- <p><strong>Correo:</strong> </p> -->
            @if (channel === 7) {
              <div>
                @for (item of arraylabels | keyvalue; track item) {
                  <p >
                    <strong>{{ item.key }}:</strong>
                    {{ item.value }}
                  </p>
                }
              </div>
            }

            <p>
              <strong>{{ getLabel('cardNumberCp') }}:</strong>
              {{ _paymentService.bindcardgen }}
            </p>
            <p>
              <strong>{{ getLabel('expirationCp') }}:</strong>
              {{ _paymentService.expiratesdatecard }}
            </p>
          </div>
          <button class="btn btn-continue btn-block" (click)="pinpage()">
            {{ getLabel('continue') }}
          </button>
          <a (click)="goBack()" class="btn-back">{{ getLabel('changeData') }}</a>
          @if (errorproceso) {
            <div class="text-center">
              <label class="mt-3 text-danger">{{ getLabel('errorProcess') }}</label>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</body>
